<template>
    <div>
        <list-component
                :items="allDocuments?.data"
                v-if="allDocuments?.data?.length"
                @open="open($event)"
                :haveDetails="true">
            <template v-slot:principal-info="{items}">
                <principal-info-component :items="items"></principal-info-component>
            </template>
            <template v-slot:date="items" v-if="!$widthMd(935)">
                <slotDateSignedComponent :items="items"></slotDateSignedComponent>
            </template>
            <template v-slot:dropdown-options="items">
                <dropdown-options-component :items="items"></dropdown-options-component>
            </template>
            <template v-slot:details-itens="items">
                <details-itens-component :items="items"></details-itens-component>
            </template>
        </list-component>
    </div>
</template>
<script>

import {useI18n} from 'vue-i18n';
import {useToast} from "vue-toastification";
import 'vue-advanced-cropper/dist/style.css';
import ListComponent from '@/components/layouts/listComponent';
import documentMixin from '../../../mixins/documentMixin';
import {mapState} from 'vuex';
import principalInfoComponent from './principalInfoComponent';
import slotDateSignedComponent from './slotDateSignedComponent';
import dropdownOptionsComponent from './dropdownOptionsComponent';
import detailsItensComponent from './detailsItensComponent';

export default {
    name: 'RunningIndex',
    components: {
        ListComponent,
        principalInfoComponent,
        slotDateSignedComponent,
        dropdownOptionsComponent,
        detailsItensComponent,
    },
    mixins: [documentMixin],
    computed: {
        ...mapState({
            allDocuments: (state) => state.document.allDocuments,
        })
    },
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
};

</script>
<style lang="less">
</style>
